// libs
import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes'

export const AiButtonsWrapper = styled('div')<{ $isTable?: boolean }>`
  background-color: ${colors.white100};
  border-radius: 25px;
  border: 1px solid ${colors.blue500};
  display: flex;
  height: 24px;
  justify-content: space-around;
  width: fit-content;
  min-width: 38px;
  z-index: 1;
  padding: 0 2px;

  ${({ $isTable }) =>
    $isTable
      ? css`
        position: absolute;
        right: 0;
        top: 0;
      `
      : css`
        position: relative;
        top: -20px;
        right: 30px;
      `};

  > div:not(:last-child) {
    border-right: 1px solid ${colors.blue500};
  }

  > div {
    padding: 0 2px;
    min-width: 24px;
  }
`

export const Button = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  cursor: pointer;

  svg {
    height: 16px;
    width: 16px;
  }

  &:hover {
    opacity: 0.8;
  }
`

